import { CircularProgress } from "@mui/material";
import styles from "./loader.module.css";

const Loader = ({ size, fullScreen, color }) => {
  return (
    <div className={styles.container} style={{ position: fullScreen ? "absolute" : "relative" }}>
      <CircularProgress color={color} size={size} />
    </div>
  );
};

export default Loader;
